var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJira(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_399_6885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1139 0H9.5083C9.5083 1.15001 9.96514 2.25292 10.7783 3.06609C11.5915 3.87927 12.6944 4.33611 13.8444 4.33611H15.6139V6.04444C15.6154 8.43704 17.5546 10.3762 19.9472 10.3778V0.833333C19.9472 0.373096 19.5741 0 19.1139 0Z",
    fill: "#2684FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3609 4.78612H4.75537C4.7569 7.17872 6.69611 9.11792 9.0887 9.11945H10.8581V10.8333C10.8612 13.2259 12.8017 15.1639 15.1943 15.1639V5.61945C15.1943 5.15921 14.8212 4.78612 14.3609 4.78612Z",
    fill: "url(#paint0_linear_399_6885)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60556 9.56944H0C0 11.9642 1.94134 13.9056 4.33611 13.9056H6.11111V15.6139C6.11264 18.0043 8.04846 19.9426 10.4389 19.9472V10.4028C10.4389 9.94254 10.0658 9.56944 9.60556 9.56944Z",
    fill: "url(#paint1_linear_399_6885)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_399_6885",
    x1: 1028.09,
    y1: 6.45284,
    x2: 621.964,
    y2: 430.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_399_6885",
    x1: 1050.83,
    y1: 14.2916,
    x2: 581.047,
    y2: 476.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_399_6885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJira);
export default __webpack_public_path__ + "static/media/jira.a829d2c850c776f501cbab8a4afac2ef.svg";
export { ForwardRef as ReactComponent };